export default __webpack_public_path__ + "static/media/koti.6dc6c287.svg";